import { render, staticRenderFns } from "./SectionTypeAddChildComponent.vue?vue&type=template&id=296adeb3&"
import script from "./SectionTypeAddChildComponent.vue?vue&type=script&lang=js&"
export * from "./SectionTypeAddChildComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports